export class UpdateCityCommand {
    public id: string;
    public image: File;
    public imageBase64: string;
    public order: number;
    public cityTitle: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/hub/update.city.command.ts